<template lang="html">
  <div>
    <div class="card">
      <div class="card-header border-0 pb-0">
        <ul class="nav nav-tabs nav-tabs-line card-header-tabs nav-fill"
            role="tablist">
          <li class="nav-item text-center"
              role="presentation">
            <a class="nav-link pt-3 text-uppercase"
               role="tab"
               :class="{active: selected=='logos'}"
               @click="selected='logos'">
              Logos
            </a>
          </li>
          <li class="nav-item text-center"
              role="presentation">
            <a class="nav-link pt-3 text-uppercase"
               href="#pad"
               role="tab"
               :class="{active: selected=='pad'}"
               @click="selected='pad'">
              Pad

            </a>
          </li>
          <li v-if="review.establishment.gathering != null"
              class="nav-item text-center"
              role="presentation">
            <a class="nav-link pt-3 text-uppercase"
               id="group-tab"
               role="tab"
               :class="{active:selected=='pad-group'}"
               @click="selected='pad-group'">
              Pad group
            </a>
          </li>
        </ul>
      </div>
      <div class="card-body p-2"
           v-if="review != null">
        <div class="tab-content">
          <div v-if="selected == 'pad'"
               class="tab-pane fade active show scroll-out"
               :class="{show: selected == 'pad'}"
               role="tabpanel">
            <Etherpad :padkey="'pad-' + review.establishment.uid"
                      :height="padHeight">
            </Etherpad>
          </div>
          <div v-if="review.establishment.gathering != null && selected == 'pad-group'"
               class="tab-pane fade active show h-100 scroll-out"
               :class="{show: selected == 'pad-group'}"
               role="tabpanel">
            <Etherpad :padkey="'pad-' + review.establishment.gathering.uid"
                      :height="padHeight">
            </Etherpad>
          </div>
          <div v-if="selected == 'logos'"
               class="tab-pane fade scroll-out custom-scroll"
               :class="{show: selected == 'logos'}"
               role="tabpanel"
               style="overflow-y:scroll;display:block;"
               :style="{height:padHeight}">
            <LogosAnswer/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Etherpad from "@/components/Etherpad.vue";
import LogosAnswer from "@/components/LogosAnswer.vue";
import settings from "@/settings.coffee";
import utils from "@/utils.js";

const pas_offset = 240;

export default {
  name: "EstablishmentInfo",
  components: {Etherpad, LogosAnswer},
  props: {
    review: Object,
    height: Boolean,
    selectPage: String
  },
  data() {
    return {
      showSignatureDropDown: false,
      toc_h1: [],
      padHeight: (window.innerHeight - pas_offset) + "px",
      currentPanel: "pad",
      panels: ["pad", "logos"],
      selected: this.selectPage ? this.selectPage : "pad"
    };
  },
  methods: {
    async get_toc() {
      const url = settings.etherpad_api_url + "getText?apikey=" + settings.etherpad_api_key + "&padID=pad-" + this.review.establishment.uid;
      const data = await this.$http.get(url);
      return data;
    },
    setHeight: utils.debounce(function () {
      this.padHeight = (window.innerHeight - pas_offset) + "px";
    }, 500),
    copySignature(signature, el) {
      const text = signature.content;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.$root.$emit('copysig', signature);

      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    }
  },
  mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  }
};
</script>

<style scoped lang="scss">
.custom-scroll {
  overflow: auto;
  scrollbar-width: none;
  padding: 0 !important;
}
</style>
